import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { CompanyContextService } from '../../../services/company-context.service';
import { AdminCancellationSettingsService } from '../../../services/cancellation-settings.service';
import { CancellationSettingsSource } from '../../../../services/cancellation-settings.service';
import { CancellationSettingsComponent } from '../../../../shared/components/cancellation-settings/cancellation-settings.component';

/**
 * CWS-1776: the Cancellation & Refund tab on the super-admin company page.
 * Hosts the shared settings panel, pointed at the company the page is scoped
 * to. The switch is a platform decision, never a shop-admin one.
 */
@Component({
  selector: 'app-company-cancellation-settings',
  standalone: true,
  imports: [CommonModule, CancellationSettingsComponent],
  templateUrl: './company-cancellation-settings.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./company-cancellation-settings.component.scss'],
})
export class CompanyCancellationSettingsComponent implements OnInit, OnDestroy {
  private readonly context = inject(CompanyContextService);
  private readonly settingsService = inject(AdminCancellationSettingsService);

  companyId = '';
  source: CancellationSettingsSource | null = null;

  private contextSub?: Subscription;

  ngOnInit(): void {
    this.contextSub = this.context.current$.subscribe(company => {
      const nextCompanyId = company?.id || '';
      if (nextCompanyId === this.companyId) {
        return;
      }
      this.companyId = nextCompanyId;
      this.source = nextCompanyId ? this.settingsService.forCompany(nextCompanyId) : null;
    });
  }

  ngOnDestroy(): void {
    this.contextSub?.unsubscribe();
  }
}
